import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.guide-card {
  padding: 16px;
  background: ${colors.baseBg};
  color: ${colors.midGrey1};
  display: flex;
  flex-direction: row;
}
.popup {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 999; /* Ensure the popup appears above other content */
}
.popup.show {
  display: block;
}
.popup-content {
  height: auto;
  position: absolute;
  top: 50%;
  width: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px;
  border-radius: 16px;
  background: #212121;
  width: 441px;
  overflow: hidden;
  box-shadow: 0px 6px 18px 6px rgba(0, 0, 0, 0.25);
}
.popup-content img {
  max-width: 100%;
  height: auto;
}
.popup-content button {
  margin-top: 10px;
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.popup-content button:hover {
  background-color: #0056b3;
}

.popup-image{
  width: 100%;
  height: 230px;
  border-radius: 16px !important;
  overflow: hidden;
}
.popup-wrap{
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
}
.episodes-link{
  border-radius: 4px;
background:  #9916C7;
width: 175px;
height: 48px;
text-align: center;
padding: 8px;
}
.popup-text{
  display: block;
    width: 100%;
    padding-top: 16px;
}
.guide-card.last {
  border-bottom: 0;
  padding-bottom: 0px;
}
.time-left{
  position: relative;
  width: auto;
  height: 20px;
  padding: 4px;
  border-radius: 2px;
  gap: 8px;
  font-family: Source Sans Pro;
  font-size: 16px;
  font-weight: 600;
  line-height: 10px;
  -webkit-letter-spacing: 0px;
  -moz-letter-spacing: 0px;
  -ms-letter-spacing: 0px;
  letter-spacing: 0px;
  text-align: right;
  margin-top: -63px;
}
.info {
  display: flex;
  flex-direction: row;
  width: 1028px;
  gap: 16px;
  align-items: normal;
  height: auto;
  border-radius: 8px;
  padding: 12px;
  background: ${colors.elevatedBg};
}
.info:hover{
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.50);
}
.info-text {
  width: 65% !important;
  display: inline-block;
  vertical-align: top;
  display: flex;
  gap: 16px;
  flex-direction: column;
  vertical-align: top;
}

.info-wrapper{
  display: flex;
  gap: 8px;
  flex-direction: column;
}

.wrapper{
  display: flex;
  gap: 10px;
  justify-content: right;
  width: 50px;
}
.popup-mylist{
  display: flex;
  gap: 10px;
  justify-content: right;
  width: 50px;
}
.live-links-wrapper {
  display: flex;
  margin-top: auto;
  flex-direction: row;
  padding 4px 0 4px 0;
}

.live-link-container {
  width: 104px;
  height: 28px;
  background: #C12A26;
  border-radius: 4px;
  text-align: center;
  margin-right: 8px;
}

.episodes-link-container {
  width: 134px;
  height: 28px;
  gap: 6px;
  border-radius: 4px;
  background: ${colors.ctvBg};
  text-align: center;
}

figcaption.live {
  color: ${colors.primaryText};
  display: flex;
  width: 40px;
  position: relative;
  background: #C12A26;
  top: -45px;
  left: 8px;
  bottom: unset;
  border-radius: 2px;
  padding: 2px 4px 2px 4px;
}

figcaption.live p.live-subtitle {
  padding-left: 4px;
  display: inline-block;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.6px;
}

.link, .live-link {
  text-transform: capitalise;
  font-weight: 600;
  font-size: 14px;
  line-height: 28px;
}

.link { color: ${colors.midText}; }

.live-link {
  padding-bottom: 5px;
  color: ${colors.primaryText};
 }

a:hover.link, a:focus.link { color: ${colors.IconButtonPurple} }

.time-stamp {
  display: flex;
  margin-bottom: 4px;
  padding: 12px;
}

.time-stamp-inner {
  font-family: Source Sans Pro;
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: right;
  color: ${colors.primaryText}
}

.card-image {
  min-width: 300px;
  height: 170px;
  display: inline-block;
  margin-right: 10px;
  margin-top: 5px;
  border-radius: 8px !important;
  overflow: hidden;
}
@media (max-height: 389px) {
  .popup-content {
    top: 64%;
  }
  .popup.show {
    overflow: scroll;
  }
}

@media (max-width: 540px) {
  .card-image {
    display: block;
    margin-top: 0px;
  }
  .wrapper{
    display: none;
  }
  .live-links-wrapper{
    display: none;
  }
  .info {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 8px;
    align-items: center;
    height: 128px;
    border-radius: 8px;
    padding: 0px 0px 0px 8px;
    background: ${colors.elevatedBg};
  }

  .info-wrapper{
    display: flex;
    flex-direction: column-reverse;
  }

  .card-image {
    min-width: 87px !important;
    height: 116px;
  }
  .info-text {
    display: flex;
    gap: 8px;
    width: 100%;
  }
  .popup-content {
    height: auto;
    min-height: 460px;
    position: fixed;
    border-radius: 16px;
    width: 96%;
  }
  .guide-card {
    padding: 0px;
    background: ${colors.elevatedBg};
    color: ${colors.midGrey1};
    display: flex;
    flex-direction: row;
    width: auto;
    height: auto;
    border-radius: 16px;
    margin-bottom: 4px;
    margin-top: 10px;
  }
}
@media (max-width: 376px) {

  .episodes-link{
    width: 150px;
  }
}
@media (max-width: 768px) {
  .guide-card.last {
    padding-bottom: 0;
  }
}

@media (max-width: 1024px) {
  .time-stamp{
    display: none;
  }

}

`
